import React from 'react';
import Modal from 'react-bootstrap/Modal';

const AlertModal = (props) => {

  return (
    <Modal show={props.alertShow} onHide={props.handleAlertClose}>
      <Modal.Header closeButton>
        <Modal.Title>
          시간 초과
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        시간이 초과되었습니다. 검색어 또는 기간을 확인해주세요.
      </Modal.Body>
      <Modal.Footer style={{display:"block",float:"left", textAlign:"right"}}>
        <a className="button purple" onClick={props.handleAlertClose}>확인</a>
      </Modal.Footer>
    </Modal>

  )
}

export default React.memo(AlertModal);